import {Component, HostListener, Input, OnInit, ViewChild,} from '@angular/core';
import {Router} from '@angular/router';
import {vappeloffre} from 'src/app/domain';
import {SearchObject} from 'src/app/domain/search/SearchObject';
import {AppeloffreService} from 'src/app/modules/services/appel-offre/appeloffre.service';
import {ConsultationService} from 'src/app/modules/services/consultation/consultation.service';
import {NewsService} from 'src/app/modules/services/news/news.service';
import {ProjetprogService} from 'src/app/modules/services/projetprog.service';
import {SearchObjectService} from 'src/app/modules/services/search-object/SearchObjectService';
import {ToastService} from 'src/app/modules/toast/toast.service';
import {News} from '../annonce-cards/annonce-cards.component';

export interface SearchView<T> {
    loading: boolean;
    options: any;
    count: number;
    results: T[];
}

@Component({
    selector: 'app-slider-image',
    templateUrl: './slider-image.component.html',
    styleUrls: ['./slider-image.component.css'],
})
export class SliderImageComponent implements OnInit {
    @ViewChild('carousel', {static: false}) carousel: any;
    searchObject: SearchObject;
    count: number;
    isLoading = {
        list: false,
    };
    searchh: SearchView<News> = {
        loading: false,
        options: undefined,
        count: 0,
        results: [],
    };
    searchhoff: SearchView<vappeloffre> = {
        loading: false,
        options: undefined,
        count: 0,
        results: [],
    };
    isLoadingoff = {
        list: false,
    };
    searchhoproj: SearchView<vappeloffre> = {
        loading: false,
        options: undefined,
        count: 0,
        results: [],
    };
    isLoadingproj = {
        list: false,
    };

    searchhcons: SearchView<vappeloffre> = {
        loading: false,
        options: undefined,
        count: 0,
        results: [],
    };
    isLoadingcons = {
        list: false,
    };
    searchObjectoff: SearchObject;
    searchObjectproj: SearchObject;
    searchObjectconsul: SearchObject;
    @Input() listappeloffres: vappeloffre[];
    imageObject: Array<object> = [
        {
            image: 'assets/images/site1.PNG',
            thumbImage: 'assets/images/site1.PNG',
        },
        {
            image: 'assets/images/site1.PNG',
            thumbImage: 'assets/images/site1.PNG',
        },
        {
            image: 'assets/images/site1.PNG',
            thumbImage: 'assets/images/site1.PNG',
        },
        {
            image: 'assets/images/site1.PNG',
            thumbImage: 'assets/images/site1.PNG',
        },
        {
            image: 'assets/images/site1.PNG',
            thumbImage: 'assets/images/site1.PNG',
        },
    ];
    im: string = 'assets/images/décret.svg';
    responsiveOptions;
    placeholder = 'Entrez votre mot-clé de recherche, exemple Transport';
    listappel: any;
    @Input() slides: any = [[]];
    // }
    CAROUSEL_BREAKPOINT = 768;
    carouselDisplayMode = 'multiple';
    news: News[] = [];

    // chunk(arr, chunkSize) {
    //   console.log("thiiis :: ",arr)
    //   let R = [];
    //   for (let i = 0, len = arr.length; i < len; i += chunkSize) {
    //     R.push(arr.slice(i, i + chunkSize));
    //   }
    //   return R;
    listoffres: vappeloffre[] = [];
    typesear: string;

    constructor(
        private offerservice: AppeloffreService,
        private router: Router,
        private newservice: NewsService,
        private searchObjectService: SearchObjectService,
        private toast: ToastService,
        private projservice: ProjetprogService,
        private consultationservice: ConsultationService
    ) {
        this.responsiveOptions = [
            {
                breakpoint: '1024px',
                numVisible: 3,
                numScroll: 3,
            },
            {
                breakpoint: '768px',
                numVisible: 2,
                numScroll: 2,
            },
            {
                breakpoint: '560px',
                numVisible: 1,
                numScroll: 1,
            },
        ];
    }

    next() {
        this.carousel.nextSlide();
    }

    prev() {
        this.carousel.previousSlide();
    }

    ngOnInit() {

        // this.slides = this.chunk(this.listappeloffres,4)
        this.searchObject = this.searchObjectService.treatementSearchObject(
            10,
            0,
            null,
            null
        );

        this.newsCards();
        if (window.innerWidth <= this.CAROUSEL_BREAKPOINT) {
            this.carouselDisplayMode = 'single';
        } else {
            this.carouselDisplayMode = 'multiple';
        }

        this.searchObjectoff = this.searchObjectService.treatementSearchObject(
            10,
            0,
            null,
            null
        );
        this.searchObjectproj = this.searchObjectService.treatementSearchObject(
            10,
            0,
            null,
            null
        );
        this.searchObjectconsul = this.searchObjectService.treatementSearchObject(
            10,
            0,
            null,
            null
        );
    }

    @HostListener('window:resize')
    onWindowResize() {
        if (window.innerWidth <= this.CAROUSEL_BREAKPOINT) {
            this.carouselDisplayMode = 'single';
        } else {
            this.carouselDisplayMode = 'multiple';
        }
    }

    verstouslesoffres(): void {
        this.router.navigateByUrl('/portail/offres');
    }

    detailsoffer(offer: vappeloffre) {
        this.router.navigate([
            '/portail/offres/details',
            offer.epBidMasterId,
            offer.bidNo,
        ]);
    }

    newsCards() {
        this.isLoading.list = true;
        this.searchObject.pagination.offSet = 0;
        this.searchObject.pagination.limit = 5;
        this.searchObject.sort = {
            'nameCol': 'modDt',
            'direction': 'DESC nulls last'
        };
        this.newservice.loadDataAdmin(this.searchObject).subscribe({
            next: (response) => {
                this.searchh.results = response['payload']['data'];
                this.searchh.count = response['payload']['total'];
            },
            error: () => {
                this.isLoading.list = false;
                this.toast.error('server_error');
            },
            complete: () => {
                this.isLoading.list = false;
            },
        });
    }

    onSearch($event) {

        if (
            this.typesear == 'Appels d' + '\'' + 'offres' ||
            this.typesear == 'دعوات المناقصات'
        ) {
            this.searchObjectoff.dataSearch = $event;

            this.offerservice.search(this.searchObjectoff).subscribe({
                next: (response) => {
                    this.searchhoff.results = response['payload']['data'];
                    this.searchhoff.count = response['payload']['total'];


                    this.router.navigate(['/portail/offres'], {
                        state: {
                            count: this.searchhoff.count,
                            data: this.searchhoff.results,
                        },
                    });
                    // this.searchh.results.filter((column) => {
                    //   this.datePipe.transform(column.bdRecvEndDt,"yyyy-MM-dd")
                    //   //  column.bdRecvEndDt = moment(column.bdRecvEndDt._d).format("YYYY-MM-DD");

                    // });
                },
                error: () => {
                    this.isLoading.list = false;
                    this.toast.error('server_error');
                },
                complete: () => {
                    this.isLoading.list = false;
                },
            });
        } else if (this.typesear == 'Projets Programmés') {
            this.searchObjectproj.pagination.offSet = 0;
            this.searchObjectproj.pagination.limit = 10;
            this.searchObjectproj.dataSearch = [];
            this.searchObjectproj.dataSearch = $event;

            this.projservice.search(this.searchObjectproj).subscribe({
                next: (response) => {
                    this.searchhoproj.results = response['payload']['data'];
                    this.searchhoproj.count = response['payload']['total'];


                    this.router.navigate(['/portail/projets'], {
                        state: {
                            count: this.searchhoproj.count,
                            data: this.searchhoproj.results,
                        },
                    });

                },
                error: () => {
                    this.isLoading.list = false;
                    this.toast.error('server_error');
                },
                complete: () => {
                    this.isLoading.list = false;
                },
            });
        } else if (this.typesear == 'Consultation') {
            this.searchObjectconsul.pagination.offSet = 0;
            this.searchObjectconsul.pagination.limit = 10;
            this.searchObjectconsul.dataSearch = [];
            this.searchObjectconsul.dataSearch = $event;

            this.consultationservice.search(this.searchObjectconsul).subscribe({
                next: (response) => {
                    this.searchhcons.results = response['payload']['data'];
                    this.searchhcons.count = response['payload']['total'];


                    this.router.navigate(['/portail/consultations'], {
                        state: {
                            count: this.searchhcons.count,
                            data: this.searchhcons.results,
                        },
                    });
                    // this.searchh.results.filter((column) => {
                    //   this.datePipe.transform(column.bdRecvEndDt,"yyyy-MM-dd")
                    //   //  column.bdRecvEndDt = moment(column.bdRecvEndDt._d).format("YYYY-MM-DD");

                    // });
                },
                error: () => {
                    this.isLoading.list = false;
                    this.toast.error('server_error');
                },
                complete: () => {
                    this.isLoading.list = false;
                },
            });
        }
    }

    onSearchtype($event) {
        this.typesear = $event;
    }
}
